'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('UserDetailsCtrl', UserDetailsCtrl);

  UserDetailsCtrl.$inject = ['Auth', 'User', 'errorMessageService',
    'Constants', 'user', 'Labels', '$mdDialog', 'modalType', 'Help', 'tenants', '$window', '$timeout'];

  function UserDetailsCtrl (Auth, User, errorMessageService,
    Constants, user, Labels, $mdDialog, modalType, Help, tenants, $window, $timeout) {

    const vm = this;
    vm.accessLevel = Auth.getUserAccessLevel();
    vm.userRoles = Constants.getList('USER_ROLES');
    vm.userLanguages = Constants.getList('USER_LANGUAGES');

    vm.user = user;
    vm.LABELS = Labels;
    vm.HELP = Help;
    vm.userLabelBtn = modalType + 'user';
    vm.databases = tenants;

    vm.userCanBeSaved = () => {
      return vm.user.accessLevel > vm.accessLevel;
    }

    vm.submitUser = (form) => {
      vm.submitted = true;
      const fullname = vm.user.nameFirst + ' ' + (vm.user.nameInfix || '') + ' ' + vm.user.nameLast;

      if (form.$valid) {
        if (modalType === 'add') {
          Auth.createUser(vm.user)
            .then((users) => {
              // Account created, redirect to users or add another if addAnother === true
              const msg = 'De gebruiker ' + fullname +
                ' is succesvol toegevoegd. Er is een activatie e-mail verstuurd naar ' + vm.user.email;
              errorMessageService.showSuccess(msg);
              $mdDialog.hide(users);
            });

        } else {
          const userToUpdate = { _id: vm.user._id as User['_id'], user: vm.user as User};
          User.update(userToUpdate).$promise.then((users: User[]) => {
            const updatedUser = users.find((u) => u._id === vm.user._id);
            if (updatedUser) {
              User.getMe().$promise.then((me: User) => {
                errorMessageService.showSuccess('gebruiker ' + updatedUser.fullName + ' is aangepast.');

                // Reload app when updating own profile and language has changed
                if (userToUpdate.user.email === me.email && form['user-language'] && !form['user-language'].$pristine) {
                  $timeout(() => {
                    $window.location.reload();
                  }, 1200);
                }
              });
            } else {
              errorMessageService.showSuccess('gebruiker ' + fullname + ' is aangepast.');
            }
            $mdDialog.hide(users);
          });

        }
      }
    };

    vm.cancel = () => {
      $mdDialog.cancel();
    };
  }
})();
